export default __webpack_public_path__ + "static/media/search.51ee79a9.svg";